/**
 * @generated SignedSource<<97474d05b2c014bd2896763801366e2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodBoletoSelected_charge$data = {
  readonly customer: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveBoleto_charge" | "PaymentCompleted_charge" | "PaymentMethodSelectedCustomerRegister_charge">;
  readonly " $fragmentType": "PaymentMethodBoletoSelected_charge";
};
export type PaymentMethodBoletoSelected_charge$key = {
  readonly " $data"?: PaymentMethodBoletoSelected_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodBoletoSelected_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodBoletoSelected_charge",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveBoleto_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedCustomerRegister_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "0dda47084eb7ff63c4c03e08f442edfe";

export default node;
